export const COLORS = {
  rowInsert: '#e6ffe6',
  rowUpdate: '#fff7c2',
};

export const styles = {
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    height: '100%',
  },
  sheetTabs: {
    padding: '8px',
  },
  tab: {
    textTransform: 'none',
    '&.Mui-selected': {
      color: '#1976d2',
      fontWeight: 600,
      backgroundColor: 'rgba(25,118,210,0.08)',
    },
  },
  legendAndNotes: {
    fontSize: 12,
    margin: '4px 8px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 2,
  },
  legendItem: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 2,
    mr: 2,
  },
  legendSquareNew: {
    display: 'inline-block',
    width: 12,
    height: 12,
    backgroundColor: COLORS.rowInsert,
    marginRight: 1,
    mr: 1,
    borderRadius: '2px',
    border: '1px solid #b2dfb2',
  },
  legendSquareUpdate: {
    display: 'inline-block',
    width: 12,
    height: 12,
    backgroundColor: COLORS.rowUpdate,
    marginRight: 1,
    mr: 1,
    borderRadius: '2px',
    border: '1px solid #ffe066',
  },
  legendText: {
    fontSize: 12,
  },
  notesList: {
    fontSize: 12,
    margin: '2px 8px 6px',
    color: '#555',
    paddingLeft: '16px',
  },
  excelPreviewContainer: {
    marginTop: 3,
    display: 'flex',
    flexDirection: 'column',
    height: 1000,
    border: '1px solid #ddd',
    borderRadius: '4px',
    overflow: 'auto',
  },
  dataTableWrapper: {
    width: '100%',
    overflow: 'visible',
    paddingTop: 4,
  },
  dataGrid: {
    border: 0,
    '& .MuiDataGrid-cell': { outline: 'none' },
    '& .MuiDataGrid-columnHeader': { outline: 'none' },
    minWidth: '100%',
    '& .insert-row .MuiDataGrid-cell': {
      backgroundColor: COLORS.rowInsert,
    },
    '& .MuiDataGrid-toolbarContainer .MuiButton-root': {
      color: 'text.primary',
    },
  },
  cellValue: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    px: 1,
    py: 0.5,
  },
};
